const ui = {
  defaultFontFamily: `"Roboto", "Noto Sans JP", "BIZ UDPゴシック", Meiryo, "ヒラギノ角ゴ Pro W3", "ヒラギノ角ゴ W3", Hiragino Kaku Gothic Pro, "Helvetica", "Arial", "ＭＳ Ｐゴシック", sans-serif;`,
  listMinWidth: "960px",
  mainMaxWidth: "1600px",
  registerMaxWidth: "1280px",
  miniRegisterMaxWidth: "800px",
}

export default ui
